// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let TipBox = require("../../common/Components/TipBox.bs.js");
let Numeral = require("../../../utils/Numeral.bs.js");
let Spinner = require("../../common/Components/Spinner.bs.js");
let Stdlib_Int = require("@rescript/runtime/lib/js/Stdlib_Int.js");
let TimePicker = require("../TimePicker.bs.js");
let Form__Label = require("../../common/Components/Form__Label.bs.js");
let LotSizeUtils = require("../../common/Property/LotSizeUtils.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let RichTextEditorV5 = require("../../common/Components/RichTextEditorV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function PropertyWizardFormRelay__Elements$IntInputField(props) {
  let value = props.value;
  let onChange = props.onChange;
  let __formatValue = props.formatValue;
  let formatValue = __formatValue !== undefined ? __formatValue : false;
  let displayValue;
  if (formatValue) {
    let value$1 = Form__Helpers.intFromFormattedNumberString(value);
    displayValue = value$1 !== undefined ? Numeral.formatNumber(value$1) : value;
  } else {
    displayValue = value;
  }
  return JsxRuntime.jsx(Form__Components.TextInputField.make, {
    value: displayValue,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    onChange: evt => onChange(formatValue ? Form__Helpers.intFromFormattedNumberString(evt.target.value) : Stdlib_Int.fromString(evt.target.value, undefined)),
    validationResult: props.validationResult,
    labelText: props.label,
    optionalText: props.optionalText,
    append: props.append,
    appendElement: props.appendElement
  });
}

let IntInputField = {
  make: PropertyWizardFormRelay__Elements$IntInputField
};

function PropertyWizardFormRelay__Elements$FloatInputField(props) {
  let value = props.value;
  let onFocus = props.onFocus;
  let onBlur = props.onBlur;
  let onChange = props.onChange;
  let value$1 = Form__Helpers.floatFromFormattedNumberString(value);
  let formattedValue = value$1 !== undefined ? LotSizeUtils.formatValue(value$1) : value;
  let match = React.useState(() => formattedValue);
  let setInputValue = match[1];
  let match$1 = React.useState(() => false);
  let setIsEditing = match$1[1];
  let isEditing = match$1[0];
  React.useEffect(() => {
    if (!isEditing) {
      setInputValue(param => formattedValue);
    }
  }, [
    formattedValue,
    isEditing
  ]);
  return JsxRuntime.jsx(Form__Components.TextInputField.make, {
    value: match[0],
    onBlur: evt => {
      setIsEditing(param => false);
      if (onBlur !== undefined) {
        return onBlur(evt);
      }
    },
    onFocus: evt => {
      setIsEditing(param => true);
      if (onFocus !== undefined) {
        return onFocus(evt);
      }
    },
    onChange: evt => {
      let nextInputValue = evt.target.value;
      let nextValue = Form__Helpers.floatFromFormattedNumberString(nextInputValue);
      setIsEditing(param => true);
      setInputValue(param => Form__Helpers.formatDecimalInputString(nextInputValue));
      onChange(nextValue);
    },
    validationResult: props.validationResult,
    labelText: props.label,
    optionalText: props.optionalText,
    append: props.append,
    appendElement: props.appendElement
  });
}

let FloatInputField = {
  make: PropertyWizardFormRelay__Elements$FloatInputField
};

function PropertyWizardFormRelay__Elements$LoadingSpinner(props) {
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(Spinner.make, {}),
    className: "absolute right-[9px] bottom-[7px] w-[21px] h-[21px] flex items-center justify-center"
  });
}

let LoadingSpinner = {
  make: PropertyWizardFormRelay__Elements$LoadingSpinner
};

function PropertyWizardFormRelay__Elements$RichTextEditorField(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsx(RichTextEditorV5.make, {
    initialContent: props.initialContent,
    onChangeFull: value => onChange(value),
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    toolbar: props.toolbar,
    height: props.height,
    status: props.status,
    labelText: props.labelText,
    optionalText: props.optionalText,
    helpText: props.helpText,
    placeholderText: props.placeholderText,
    editorRef: props.forwardRef
  });
}

let RichTextEditorField = {
  RichTextEditor: undefined,
  make: PropertyWizardFormRelay__Elements$RichTextEditorField
};

function PropertyWizardFormRelay__Elements$TimePicker(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: props.label
      }),
      JsxRuntime.jsx(TimePicker.make, {
        placeholder: props.placeholder,
        value: props.value,
        onChange: props.onChange,
        startTime: props.startTime,
        endTime: props.endTime,
        onBlur: props.onBlur,
        onFocus: props.onFocus,
        hourlyIntervals: props.hourlyIntervals,
        isClearable: props.isClearable
      })
    ]
  });
}

let TimePicker$1 = {
  make: PropertyWizardFormRelay__Elements$TimePicker
};

function PropertyWizardFormRelay__Elements$RebroadcastMessageTipBox(props) {
  return JsxRuntime.jsx(TipBox.make, {
    title: "Message for TAN colleagues",
    children: JsxRuntime.jsx("p", {
      children: "Tell your TAN colleagues why you're rebroadcasting this property. This message is not shared with clients."
    })
  });
}

let RebroadcastMessageTipBox = {
  make: PropertyWizardFormRelay__Elements$RebroadcastMessageTipBox
};

function PropertyWizardFormRelay__Elements$RebroadcastHeadlineTipBox(props) {
  return JsxRuntime.jsx(TipBox.make, {
    title: "Headline",
    children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("p", {
          children: "Enter a new headline that summarizes why you are rebroadcasting this property."
        }),
        JsxRuntime.jsx("p", {
          children: "Examples: Photos are in! Designer unit 50 Liberty, Available this weekend by appointment, BOM, Major price drop coming soon."
        })
      ]
    })
  });
}

let RebroadcastHeadlineTipBox = {
  make: PropertyWizardFormRelay__Elements$RebroadcastHeadlineTipBox
};

let TipBox$1;

exports.IntInputField = IntInputField;
exports.FloatInputField = FloatInputField;
exports.LoadingSpinner = LoadingSpinner;
exports.RichTextEditorField = RichTextEditorField;
exports.TimePicker = TimePicker$1;
exports.TipBox = TipBox$1;
exports.RebroadcastMessageTipBox = RebroadcastMessageTipBox;
exports.RebroadcastHeadlineTipBox = RebroadcastHeadlineTipBox;
/* react Not a pure module */
